import React from 'react';
import { cn } from '@utils/classNames';
import { formatBytes } from '@utils/format';

interface SidebarStorageCardProps {
  storageUsed: number;
  storageLimit: number;
  storagePercentage: number;
  totalFiles: number;
  className?: string;
}

export const SidebarStorageCard: React.FC<SidebarStorageCardProps> = ({
  storageUsed,
  storageLimit,
  storagePercentage,
  totalFiles,
  className,
}) => (
  <div
    className={cn(
      'p-3.5 rounded-xl bg-white/[0.06] border border-white/[0.08] transition-colors hover:bg-white/[0.08]',
      className
    )}
  >
    <h3 className="font-dela text-xs font-medium text-white/90 uppercase tracking-wider mb-2.5">
      Storage
    </h3>
    <div className="w-full h-1.5 rounded-full bg-white/10 mb-2.5 overflow-hidden">
      <div
        className="h-full rounded-full bg-primary transition-all duration-300 ease-out"
        style={{ width: `${Math.min(storagePercentage, 100)}%` }}
      />
    </div>
    <div className="flex items-center justify-between mb-0.5">
      <span className="font-inter text-[11px] text-white/70 tabular-nums">
        {formatBytes(storageUsed)} / {formatBytes(storageLimit)}
      </span>
      <span className="font-inter text-[11px] font-semibold text-white/90 tabular-nums">
        {storagePercentage}%
      </span>
    </div>
    <p className="font-inter text-[10px] text-white/50">
      {totalFiles} {totalFiles === 1 ? 'File' : 'Files'}
    </p>
  </div>
);
